// @flow
import React from 'react';
import './WarningText.css';

const WarningText = () => (
  <div className="WarningText-warning-box">
    Vi reserverar oss för utgående produkter och förändringar av fabrikat. Färgåtergivning kan variera.
  </div>
);

export default WarningText;



// WEBPACK FOOTER //
// ./src/components/WarningText/WarningText.js